import React, { Component } from "react";
import { observer } from "mobx-react";
import { comma } from "../../../../utils/Utils";
import { fn_self_devliery_request, fn_self_devliery_send } from "../../../../function/FnBodyDelivery";
import { fn_closeDetailView } from "../../../../function/FnBodyDetail";
import { fn_setDepositCheck } from "../../../../function/FnBodyLayer";

@observer
class CheckDepositView extends Component {

    constructor(props) {
        super(props);
    }

    requestDeposit = () => {
        const { rootStore } = this.props;
        rootStore.orderStore.setcheckDeposit({
            payFg: rootStore.layerStore.getDepositCheck,
            stepCd: '700'
        })
        fn_self_devliery_send(rootStore)
        let tempOrderNo = rootStore.viewStore.getOrderDetail.orderNo;
        if (rootStore.viewStore.getOrderDetail.mobileOrderFg == "22" && rootStore.viewStore.getOrderDetail.partnerType.toUpperCase() == "WMPO" && rootStore.viewStore.getOrderDetail.registNumber != null) {
            tempOrderNo = rootStore.viewStore.getOrderDetail.registNumber
        }

        if (rootStore.viewStore.getOrderDetail.mobileOrderFg == "22" && rootStore.viewStore.getOrderDetail.partnerType.toUpperCase() == "SPECIALDELIVERY" && rootStore.viewStore.getOrderDetail.registNumber != null) {
            tempOrderNo = rootStore.viewStore.getOrderDetail.registNumber
        }

        let data = { partnerType: rootStore.viewStore.getOrderDetail.partnerType, morderTypeCd: rootStore.viewStore.getOrderDetail.morderTypeCd, orderNo: tempOrderNo, mobileOrderNo: rootStore.viewStore.getOrderDetail.mobileOrderNo, mobileOrderFg: rootStore.viewStore.getOrderDetail.mobileOrderFg, type: "order_complete" }
        fn_closeDetailView(rootStore)
    }

    cancelDeposit = () => {
        const { rootStore } = this.props;
        rootStore.orderStore.setcheckDeposit({
            payFg: '',
            stepCd: ''
        })
        rootStore.layerStore.setLayerCheckDeposit(false)
    }
    render() {
        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;
        let order = this.props.rootStore.viewStore.getOrderDetail;

        return (
            <div className={"layer_comm layer_common_type " + (layerStore.getLayerCheckDepositView ? ' layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_tit_comm">
                            <h1>수금 확인</h1>
                        </div>
                        <div className="section_collection">
                            <h2>총 결제금액 <strong><span>{comma(order.orderAmount)}</span>원</strong></h2>
                            <div className="list_radio">
                                <label><input type="radio" name="collection" checked={rootStore.layerStore.getDepositCheck == "02" ? true : false} onChange={event => fn_setDepositCheck(rootStore, "02")} /><span>카드</span></label>
                                <label><input type="radio" name="collection" checked={rootStore.layerStore.getDepositCheck == "01" ? true : false} onChange={event => fn_setDepositCheck(rootStore, "01")} /><span>현금</span></label>
                            </div>
                            <div className="wrap_full_btn">
                                <span className="f_l"><button className="btn_cancel" onClick={this.cancelDeposit}>취소</button></span>
                                <span className="f_r"><button className="btn_submit" onClick={this.requestDeposit}>확인</button></span>
                            </div>
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button onClick={event => layerStore.setLayerCheckDeposit(false)}><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CheckDepositView;